import { Component, ChangeDetectionStrategy } from "@angular/core";
import { ProcessCollectionComponent } from "process/table/process-collection.component";
import { AsyncPipe, NgTemplateOutlet } from "@angular/common";
import { DescriptionViewComponent } from "common/editor/description-view.component";
import { RouterLink } from "@angular/router";

@Component({
	selector: "stages-process-list",
	templateUrl: "./process-list.component.html",
	styleUrls: ["./process-list.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [DescriptionViewComponent, RouterLink, NgTemplateOutlet, AsyncPipe],
})
export class ProcessListComponent extends ProcessCollectionComponent {
	properties: unknown;

	constructor() {
		super();
	}
}
